// The page's one polite live region for copy results. It renders beside the table, outside it, and a cell
// announces through announceCopy, so the result reaches screen readers without a toast.

import React, { useEffect, useState } from 'react'

const listeners = new Set()
let alternate = false

export const copiedMessage = coursenum => `Copied course number ${coursenum}`
export const copyFailedMessage = coursenum =>
  `Couldn't copy course number ${coursenum}`

/** Announces one copy result in every mounted region. */
export const announceCopy = message => {
  // a repeated message still changes the region's text, so it is read again
  alternate = !alternate
  const text = alternate ? message : `${message}\u00a0`
  listeners.forEach(listener => listener(text))
}

export const CopyLiveRegion = () => {
  const [text, setText] = useState('')
  useEffect(() => {
    listeners.add(setText)
    return () => {
      listeners.delete(setText)
    }
  }, [])
  return (
    <div className="sr-only" role="status" aria-live="polite">
      {text}
    </div>
  )
}
